import cn from 'classnames'
import * as React from 'react'

import styles from './textblock.module.scss'

import SubTitle from '../sub-title'

interface ITextblockProps {
  description: React.ReactNode
  extra?: React.ReactNode
  link?: {
    href: string
    text: React.ReactNode
  }
  showSeparator?: boolean
  hideSeparator?: boolean
  subTitle?: React.ReactNode
  title: React.ReactNode
  variant?: 'free' | 'regular'
}
const Textblock = ({
  variant = 'regular',
  description,
  extra,
  link,
  showSeparator,
  hideSeparator,
  subTitle,
  title,
}: ITextblockProps) => (
  <>
    {subTitle && (
      <SubTitle className={cn(styles.subTitle)} color={variant === 'free' ? 'free' : 'brand'}>
        {subTitle}
      </SubTitle>
    )}
    <h2 className={cn(styles.title, variant === 'free' && styles.freeTitle)}>{title}</h2>
    <p className={cn(styles.description, variant === 'free' && styles.freeDescription)}>{description}</p>
    {(extra || showSeparator) && !hideSeparator && (
      <hr className={cn(styles.separator, variant === 'free' && styles.freeSeparator)} />
    )}
    {extra && <div className={cn(styles.extra, variant === 'free' && styles.freeDescription)}>{extra}</div>}
    {link && (
      <a className={cn(styles.link, variant === 'free' && styles.freeLink)} href={link.href}>
        {link.text}
        {' ›'}
      </a>
    )}
  </>
)

export default Textblock
